(function () {
  'use strict';
  if (window.__bfMobileTopLoaded) return;
  window.__bfMobileTopLoaded = true;
  var mobile = window.matchMedia('(max-width: 767px)');
  function motion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
  function initNav(root) {
    if (root.dataset.bfNavInit) return;
    root.dataset.bfNavInit = 'true';
    var bar = root.querySelector('.bf-m-nav__bar');
    var links = Array.from(root.querySelectorAll('[data-bf-nav-target]'));
    function update() {
      if (!root.isConnected) return;
      root.classList.toggle('is-stuck', mobile.matches && root.getBoundingClientRect().top <= 0);
      var active = links[0];
      var activeTop = -Infinity;
      var atBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2;
      links.forEach(function (link) {
        var section = document.getElementById(link.dataset.bfNavTarget);
        if (!section) return;
        var top = section.getBoundingClientRect().top;
        if ((top <= bar.offsetHeight + 8 || (atBottom && top < window.innerHeight)) && top > activeTop) { active = link; activeTop = top; }
      });
      links.forEach(function (link) {
        link.classList.toggle('is-active', link === active);
        if (link === active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById(link.dataset.bfNavTarget);
        if (!target) return;
        event.preventDefault();
        window.scrollTo({ top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - bar.offsetHeight), behavior: motion() });
      });
    });
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function initCalendar(root) {
    if (root.dataset.bfCalendarInit) return;
    root.dataset.bfCalendarInit = 'true';
    var year = Number(root.dataset.bfCalendarYear) || 2026;
    var grid = root.querySelector('[data-bf-calendar-dates]');
    var tabs = Array.from(root.querySelectorAll('[data-bf-month]'));
    var entries = Array.from(root.querySelectorAll('[data-bf-giveaway]'));
    var dialog = root.querySelector('dialog');
    var lastFocus;
    var artwork = root.querySelector('.bf-m-calendar__art');
    [10,11,12].forEach(function (month) { var preload = new Image(); preload.src = root.getAttribute('data-bf-scene-' + month); });
    function highlighted(month, day) {
      if (month === 10 && (day === 20 || day === 27)) return true;
      if (year === 2026 && month === 11 && (day === 3 || day === 10 || day === 17 || day === 20 || (day >= 23 && day <= 30))) return true;
      return false;
    }
    function fillConfetti(layer) { if (window.BFCalendarConfetti) window.BFCalendarConfetti.start(layer); }
    function openDialog() {
      if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); }
      else dialog.setAttribute('open', '');
    }
    function show(title, content) {
      lastFocus = document.activeElement;
      if (window.BFCalendarConfetti) window.BFCalendarConfetti.stop(root.querySelector('[data-bf-confetti]'));
      dialog.classList.remove('is-prize', 'is-pre-prize');
      root.querySelector('[data-bf-prize]').hidden = true;
      root.querySelector('[data-bf-confetti]').hidden = true;
      root.querySelector('[data-bf-howto]').hidden = false;
      root.querySelector('[data-bf-calendar-dialog-title]').textContent = title;
      root.querySelector('[data-bf-calendar-dialog-content]').replaceChildren();
      Array.from(content.childNodes).forEach(function (child) { root.querySelector('[data-bf-calendar-dialog-content]').appendChild(child.cloneNode(true)); });
      openDialog();
    }
    function openPrize(month, day) {
      lastFocus = document.activeElement;
      if (root.hasAttribute('data-bf-prelaunch')) { window.BFPreCalendar.show(root, year, month, day); return; }
      dialog.classList.add('is-prize');
      root.querySelector('[data-bf-howto]').hidden = true;
      root.querySelector('[data-bf-prize]').hidden = false;
      root.querySelector('[data-bf-prize-range]').textContent = month === 11 ? (root.dataset.bfRange11 || '11.3-11.30') : (root.dataset.bfRange10 || '10.1-10.27');
      var layer = root.querySelector('[data-bf-confetti]');
      layer.hidden = false;
      fillConfetti(layer);
      openDialog();
    }
    function render(month) {
      root.classList.toggle('is-nov3-calendar', root.hasAttribute('data-bf-revealed-third-week') && month === 11);
      root.dataset.bfMonth = String(month);
      artwork.src = root.getAttribute('data-bf-scene-' + month);
      var tab = tabs.find(function (item) { return Number(item.dataset.bfMonth) === month; });
      tabs.forEach(function (item) { var active = item === tab; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
      grid.replaceChildren();
      grid.classList.toggle('is-alternate', month === 11);
      grid.classList.toggle('is-mystery', month === 12);
      grid.setAttribute('aria-label', tab.querySelector('span').textContent + ' giveaway dates');
      var monthLabel = root.querySelector('[data-bf-month-label]');
      monthLabel.hidden = true;
      monthLabel.textContent = tab.querySelector('span').textContent.slice(0, 3);
      ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].forEach(function (day) { var el = document.createElement('span'); el.className = 'bf-m-calendar__weekday'; el.textContent = day; grid.appendChild(el); });
      var start = (new Date(year,month - 1,1).getDay() + 6) % 7;
      var count = new Date(year,month,0).getDate();
      var firstDay = year === 2026 && month === 11 ? 2 : 1;
      if (firstDay === 2) start = 0;
      var rows = Math.ceil((start + count - firstDay + 1) / 7);
      grid.style.gridTemplateRows = 'calc(15 * var(--bf-m)) repeat(' + rows + ', 1fr)';
      for (var cell = 0; cell < rows * 7; cell++) {
        var day = cell - start + firstDay;
        var date = year + '-' + String(month).padStart(2,'0') + '-' + String(day).padStart(2,'0');
        var entry = entries.find(function (item) { return item.dataset.bfGiveaway === date; });
        var inMonth = day > 0 && day <= count;
        var mystery = month === 12;
        var giveaway = inMonth && !mystery && (!!entry || highlighted(month, day));
        var button = document.createElement(giveaway ? 'button' : 'span');
        button.className = 'bf-m-calendar__day' + (giveaway ? ' is-giveaway' : '');
        if (mystery && inMonth) { button.textContent = '?'; button.setAttribute('aria-hidden', 'true'); }
        else if (inMonth) { button.textContent = day; button.setAttribute('aria-label', tab.querySelector('span').textContent + ' ' + day + ', ' + year + (giveaway ? ' giveaway details' : '')); }
        if (button.tagName === 'BUTTON') {
          button.type = 'button';
          (function (node, eventEntry, eventMonth, eventDay) { node.addEventListener('click', function () {
            if (!root.hasAttribute('data-bf-prelaunch') && eventEntry && (eventEntry.textContent.trim() || eventEntry.querySelector('img'))) show(eventEntry.dataset.bfGiveawayTitle, eventEntry);
            else openPrize(eventMonth, eventDay);
          }); })(button, entry, month, day);
        }
        if (giveaway) { var ripple = document.createElement('span'); ripple.className = 'bf-date-ripple'; ripple.setAttribute('aria-hidden','true'); button.appendChild(ripple); }
        grid.appendChild(button);
      }
    }
    tabs.forEach(function (tab,index) {
      tab.addEventListener('click', function () {
        render(Number(tab.dataset.bfMonth));
        var scroller = tab.parentElement;
        var left = scroller.scrollLeft;
        var inset = parseFloat(getComputedStyle(scroller).paddingLeft) || 0;
        if (tab.offsetLeft < left + inset) left = tab.offsetLeft - inset;
        else if (tab.offsetLeft + tab.offsetWidth > left + scroller.clientWidth - inset) left = tab.offsetLeft + tab.offsetWidth - scroller.clientWidth + inset;
        scroller.scrollTo({ left: Math.max(0, left), behavior: motion() });
      });
      tab.addEventListener('keydown', function (event) {
        var next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : -1;
        if (next < 0) return;
        event.preventDefault(); tabs[next].focus(); tabs[next].click();
      });
    });
    root.querySelector('[data-bf-calendar-how]').addEventListener('click', function () { show('How to Win',root.querySelector('[data-bf-giveaway-instructions]')); });
    root.querySelectorAll('[data-bf-calendar-close]').forEach(function (button) {
      button.addEventListener('click', function () { if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open'); });
    });
    dialog.addEventListener('close', function () { if (lastFocus && lastFocus.isConnected) lastFocus.focus(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) { var bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close(); } });
    render(Number(root.dataset.bfInitialMonth) || 10);
  }
  function init(root) {
    root.querySelectorAll('[data-bf-mobile-nav]').forEach(initNav);
    root.querySelectorAll('[data-bf-calendar]').forEach(initCalendar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
